import { render, staticRenderFns } from "./BookCatagory.vue?vue&type=template&id=16a05291&"
import script from "./BookCatagory.vue?vue&type=script&lang=js&"
export * from "./BookCatagory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports